/*
*
* Interview API:
* - interview_scheduling
 */

window.InterviewAPI =  new function() {
  var self = this;
  var _protected = BaseAPI.call(self);

  /***
   * Set interview schedule (draws calender)
   *
   *
   * @param job_id
   * @param brandId
   * @param locationId
   * @param slots
   * @param duration
   * @param allowOverlap
   * @returns {deferred.promise|{then, always}}
   */
  self.setSlots = function(job_id,brandId,locationId,slots,duration,allowOverlap){

    var requestPayload = {
      "calendar": slots,
      "duration": duration,
      "allow_overlap": allowOverlap || false,
      "brand_id": brandId
    };

    if(locationId){
      requestPayload.location_id = locationId;
    }

    var deferred = $q.defer();
    _protected.request('interview/schedule/'+job_id, 'PUT',requestPayload).then(function(data){
      _protected.handleResponse(data.data, deferred);
    }, function(e){
      deferred.reject(e);
    });

    return deferred.promise;
  };

  self.setJobInterviewSettings = function (brandId, jobId, payload) {

      var deferred = $q.defer();

      _protected.request('brands/' + brandId + '/jobs/' + jobId + '/settings/interview', 'PUT', payload)
          .then(function (res) {
              deferred.resolve(res.data.data);
          }, function (err) {
              deferred.reject(err);
          });

      return deferred.promise;
  };

  /***
   * Delete single time slot of the interview schedule
   *
   * @param job_id
   * @param slot_id
   * @returns {deferred.promise|{then, always}}
   */
  self.deleteSlot = function(job_id,slot_id){

    var requestPayload = {
      "slot_id": slot_id
    };

    var deferred = $q.defer();
    _protected.request('interview/schedule/'+job_id, 'DELETE',requestPayload).then(function(data){
      _protected.handleResponse(data.data, deferred);
    }, function(e){
      deferred.reject(e);
    });

    return deferred.promise;
  }

  /****
   * Get schedule slots for specific job (EMPLOYER)
   *
   * @param jobId
   * @param brandId
   * @returns {deferred.promise|{then, always}}
   */
  self.getSlotsEmployer = function(jobId,brandId){
    var deferred = $q.defer();
    _protected.request("interview/schedule/"+jobId+"/"+brandId, 'GET').then(function(data){
        if(data && data.data && data.data.data && data.data.status_code == 200){

          var slotsBE =  data.data.data.slots;
          var slots = [];
          for(var i in slotsBE){
            var slotObj = slotsBE[i].schedule_slot;
            slotObj.start_time = new Date(slotObj.start_time);
            slotObj.end_time = new Date(slotObj.end_time);
            if(slotsBE[i].reserved_by){
              slotObj.reserved_by = slotsBE[i].reserved_by;
            }
            slots.push(slotObj);
          }

          var dataResolve = {};
          dataResolve.slots = slots;
          if(data.data.data.duration){
            dataResolve.duration = data.data.data.duration;
          }

          if(data.data.data.allow_overlap){
            dataResolve.allow_overlap = data.data.data.allow_overlap;
          }

          if(data.data.data.location){
            dataResolve.location = data.data.data.location;
          }

          deferred.resolve(dataResolve);

        }else{
          deferred.reject(data.data);
        }
    }, function(e){
      deferred.reject(e);
    });

    return deferred.promise;
  }

  /***
   * Send Interview
   * @param data
   * @returns {deferred.promise|{then, always}}
   */
  self.sendInterview = function(job_id,candidate_id,message,location_id,brand_id){

    var requestPayload = {
      'job_id':job_id,
      'candidate_id':candidate_id,
      'message':message,
      'brand_id': brand_id
    };

    if(location_id){
      requestPayload.location_id = location_id;
    }

    var deferred = $q.defer();
    _protected.request('job_applications/interview', 'PUT',requestPayload).then(function(data){
      _protected.handleResponse(data.data, deferred);
    }, function(e){
      deferred.reject(e);
    });

    return deferred.promise;
  }


  self.getUserInterviews = function(){

    var deferred = $q.defer();

    _protected.request('user/interviews', 'GET').then(function(data){

      if(data && data.data && data.data.data && data.data.status_code == 200){
        var returnedResult = data.data.data;

        var result = {};


        if(returnedResult && returnedResult.interviews && returnedResult.interviews.length>0){
          result.interviews = [];
          for(var i in returnedResult.interviews){
            if(returnedResult.interviews[i] && returnedResult.interviews[i].JobScheduleSlots && returnedResult.interviews[i].JobScheduleSlots.length>0){
              for(var j in returnedResult.interviews[i].JobScheduleSlots){
                var intObj = {};
                intObj.end_time = new Date(returnedResult.interviews[i].JobScheduleSlots[j].end_time);
                intObj.start_time = new Date(returnedResult.interviews[i].JobScheduleSlots[j].start_time);
                intObj.date = new Date(returnedResult.interviews[i].JobScheduleSlots[j].start_time);
                intObj.interview_id = returnedResult.interviews[i].id;
                intObj.id = returnedResult.interviews[i].JobScheduleSlots[j].id;
                intObj.status = returnedResult.interviews[i].status;
                result.interviews.push(intObj);
              }
            }
          }
        }


        if(returnedResult && returnedResult.next && returnedResult.next.id){
          result.next = {};

          if(returnedResult.next.JobScheduleSlots && returnedResult.next.JobScheduleSlots.start_time){
            result.next.start_time = new Date(returnedResult.next.JobScheduleSlots.start_time);
            result.next.date = new Date(returnedResult.next.JobScheduleSlots.start_time);
          }

          if(returnedResult.next.JobScheduleSlots && returnedResult.next.JobScheduleSlots.end_time){
            result.next.end_time = new Date(returnedResult.next.JobScheduleSlots.end_time);
          }

          if(returnedResult.next.Location){
            result.next.location = returnedResult.next.Location;
          }

          result.next.id = returnedResult.next.id;
          result.next.status = returnedResult.next.status;
          result.next.brand = {
            name: returnedResult.next.name,
            profile_image_uuid: returnedResult.next.uuid,
            id: returnedResult.next.brand_id
          };

          result.next.position = returnedResult.next.Position;
          if(returnedResult.next.alias_position){
            result.next.position.alias_position = returnedResult.next.alias_position;
          }

          result.next.job_application_id  = returnedResult.next.job_application_id;
        }

        deferred.resolve(result);
      }else{
        deferred.reject(data.data);
      }

    }, function(e){
      deferred.reject(e);
    });

    return deferred.promise;
  }

  self.getUserInterview = function(interviewId){

    var deferred = $q.defer();
    _protected.request('user/interviews/'+interviewId, 'GET').then(function(data){
       if(data && data.data && data.data.data && data.data.status_code == 200){
          var result = {};

           if(data.data.data.JobScheduleSlots && data.data.data.JobScheduleSlots.start_time){
             result.start_time = new Date(data.data.data.JobScheduleSlots.start_time);
             result.date = new Date(data.data.data.JobScheduleSlots.start_time);
           }

           if(data.data.data.JobScheduleSlots && data.data.data.JobScheduleSlots.end_time){
             result.end_time = new Date(data.data.data.JobScheduleSlots.end_time);
           }

          result.location = data.data.data.Location;
          result.id = data.data.data.id;
          result.status = data.data.data.status;
          result.brand = {
            name: data.data.data.name,
            profile_image_uuid: data.data.data.uuid,
            id: data.data.data.brand_id
          };
          result.position = data.data.data.Position;
          if(data.data.data.alias_position){
            result.position.alias_position = data.data.data.alias_position;
          }
          result.job_application_id  = data.data.data.job_application_id;
          deferred.resolve(result);
        }else{
          deferred.reject(data.data);
        }

      }, function(e){

      deferred.reject(e);
    });

    return deferred.promise;
  }


  /***
   * Send Interview
   * @param interviewId
   * @returns {deferred.promise|{then, always}}
   */
  self.denyInterview = function(interviewId){

    var requestPayload = {
      "status": "Denied",
    };

    var deferred = $q.defer();
    _protected.request('interview_status/' + interviewId, 'POST',requestPayload).then(function(data){
        if(data && data.data && data.data.status_code == 200){
          deferred.resolve(data.data.data);
        }else{
          deferred.reject(data.data);
        }
    }, function(e){
      deferred.reject(e);
    });

    return deferred.promise;

  }


  /**
   *
   * Get E-Signed second phase
   *
   * @param appId
   * @returns {deferred.promise|{then, always}}
   */
  self.getPdfSignedLink = function(job_id,candidate_id){
    var deferred = $q.defer();
    _protected.request(publicConfiguration.OnboardingServerBaseURL + 'digital_application/pdf_signed_link/' + job_id + '/' +candidate_id, 'GET').then(function(data){

      if(data && data.data && data.data.data && data.data.data.link && data.data.status_code == 200){
        deferred.resolve(data.data.data.link);
      }else{
        deferred.reject(data.data);
      }
    }, function(e){
      deferred.reject(e);
    });

    return deferred.promise;
  }

};


InterviewAPI.INTERVIEW_STATUS = {
  CONFIRMED: 'CONFIRMED',
  DENIED: 'DENIED',
  SENT: 'SENT'
};
